import React from 'react';
import './TruncatedCell.css';

const DEFAULT_MAX_LENGTH = 20;

/**
 * テーブルセル用のテキスト省略コンポーネント（CSS-onlyポップオーバー）。
 * maxLength 文字を超える場合は省略し、ホバー時にポップオーバーで全文を表示する。
 * state を持たない純粋な描画コンポーネントのため、大量行でも軽量。
 *
 * @param {string} text - 表示するテキスト
 * @param {number} [maxLength=20] - 省略する文字数（デフォルト: 20）
 */
function TruncatedCell({ text, maxLength = DEFAULT_MAX_LENGTH }) {
    const shouldTruncate = text && text.length > maxLength;
    const displayText = shouldTruncate
        ? text.substring(0, maxLength) + '…'
        : (text || '');

    if (!shouldTruncate) {
        return <span>{displayText}</span>;
    }

    return (
        <span className="truncated-cell">
            {displayText}
            <span className="truncated-cell-popover">{text}</span>
        </span>
    );
}

export default React.memo(TruncatedCell);
